<template>
    <div
        class="gdc-filterable-items col-md-4 col-6 m-0 p-0 gdc-free-slot-game"
        data-inc="GDC - Slot Game Item"
        :id="'game-' + slotGame.id"
    >
        <div class="card item p-0 overflow-hidden">
            <a :href="slotGame.review_link" :title="slotGame.title">
                <div class="logo">
                    <img
                        class="w-100 img-fluid grid-thumb lazypreload lazyload"
                        :data-src="slotGame.images.main"
                        :alt="slotGame.short_title"
                    />
                </div>
            </a>
            <div class="card-body p-0">
                <div class="slot-ribbon pt-2 pb-2">
                    <span v-if="slotGame.game.slot_ribbon_name">{{
                        slotGame.game.slot_ribbon_name
                    }}</span>
                </div>
                <div class="automation-title title pt-0 pb-2">
                    <a :href="slotGame.review_link" :title="slotGame.title">
                        {{ slotGame.short_title }}
                        <img class="lazyload img-fluid d-inline ml-2" width="7" height="11" :data-src="slotGame.images.next" alt="next">
                    </a>
                </div>
                <div v-if="isFreeSlotGame || (geo === 'US')">
                    <a  :href="slotGame.review_link" :title="slotGame.title"
                        class="slots-button btn"
                        rel="nofollow"
                        target="_blank"
                    >
                        <span class="text">{{ playLabelFreeText }}</span>
                        <span class="text">{{ slotGame.game.feature_name }}</span>
                        <span class="arrow-box">
                            <img class="lazyload img-fluid d-inline" width="20" height="20" :data-src="slotGame.images.play" alt="next">
                        </span>
                    </a>
                </div>
                <div v-else>
                    <exit-link-button-elements
                        :offer="slotGame.offer[0]"
                        :cta="'slot_game_list_' + slotGame.order"
                        :cta-location="'slot_game_list_' + slotGame.order"
                        :gtm="'slot_game_list_cta ' + slotGame.offer[0].product.brand_name + ' pos=' + slotGame.order"
                        :css="'slots-button btn exit-click-cta exit-page-link'"
                        v-cloak
                    >
                        <span class="text">{{ playLabelText}}</span>
                        <span class="arrow-box">
                            <img class="lazyload img-fluid d-inline" width="20" height="20" :data-src="slotGame.images.play" alt="next">
                        </span>
                    </exit-link-button-elements>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ExitLinkButtonElements from '../operator_list/ExitLinkButtonElements.vue';
export default {
    components: { ExitLinkButtonElements },
    props: {
        slotGame: Object,
        isFreeSlotGame: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        geo() {
            return document.querySelector('[name="geo.region"]').content.toUpperCase();
        },
        playLabelText() {
            return window.translations.slotGameCTA.play_label || 'Play Now';
        },
        playLabelFreeText() {
            return window.translations.slotGameCTA.play_label_free || 'Play for free';
        }
    }
};
</script>
